import type { Uppy } from '@uppy/core';
import { createContext, useContext } from 'react';
import type { CloudStorageProviderDetails } from './types';

const UppyContext = createContext<{
  uppyInstance: { Uppy: Uppy | null; loading?: boolean };
  cloudStorageProviderDetails: CloudStorageProviderDetails | undefined;
}>({
  uppyInstance: {
    Uppy: null,
  },
  cloudStorageProviderDetails: undefined,
});

export const useUppyContext = () => {
  const value = useContext(UppyContext);

  if (!value.uppyInstance.Uppy && !value.uppyInstance.loading) {
    throw new Error('[UppyContext] Not initialised');
  }

  return value;
};

export default UppyContext;
